var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 14, height: 14, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M5.833 5.833H1.17a1.168 1.168 0 1 0 0 2.334h4.663v4.663a1.168 1.168 0 1 0 2.334 0V8.167h4.663A1.168 1.168 0 0 0 14 7c0-.649-.524-1.167-1.17-1.167H8.167V1.17a1.168 1.168 0 1 0-2.334 0v4.663Z", fill: "currentColor" }));
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUuODMzIDUuODMzSDEuMTdhMS4xNjggMS4xNjggMCAxIDAgMCAyLjMzNGg0LjY2M3Y0LjY2M2ExLjE2OCAxLjE2OCAwIDEgMCAyLjMzNCAwVjguMTY3aDQuNjYzQTEuMTY4IDEuMTY4IDAgMCAwIDE0IDdjMC0uNjQ5LS41MjQtMS4xNjctMS4xNy0xLjE2N0g4LjE2N1YxLjE3YTEuMTY4IDEuMTY4IDAgMSAwLTIuMzM0IDB2NC42NjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
